export class SetPasswordModel {
    userId: string;
    password: string;
    confirmPassword: string;

    constructor(userId: string,
        password: string,
        confirmPassword: string) {
            this.userId = userId;
            this.password= password;
            this.confirmPassword= confirmPassword;
        }
}